<form novalidate #propertyInformationSectionForm="ngForm">
    <tg-row
        class="property-information-section__container"
        *ngIf="draftLoaded$ | async"
    >
        <tg-col md="9" sm="12">
            <tg-row>
                <tg-col sm="12">
                    <h1 class="property-information-section__section-heading">
                        Property information
                    </h1>
                </tg-col>
            </tg-row>
            <tg-row>
                <property-information-notice class="property-information-section__info-notice" *ngIf="isDisabledInput"></property-information-notice>
            </tg-row>
            <tg-row>
                <tg-col lg="2" md="3" sm="6">
                    <tg-input-container
                        class="hide-optional-label"
                        label="Street #"
                        showRemainingCharacters="false"
                    >
                        <input
                            tgTextInput
                            name="streetNo"
                            type="text"
                            (blur)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.streetNumber
                            "
                            size="large"
                            [validation]="
                                validation.propertyInformation.streetNumber
                                    | toValidator
                            "
                            [disabled]="isDisabledInput"
                        />
                    </tg-input-container>
                </tg-col>
                <tg-col lg="2" md="3" sm="6">
                    <tg-input-container
                        class="hide-optional-label"
                        label="Unit / Flat"
                        showRemainingCharacters="false"
                    >
                        <input
                            tgTextInput
                            name="unit"
                            type="text"
                            (blur)="publish()"
                            [(ngModel)]="draftData.propertyInformation.unitFlat"
                            [validation]="
                                validation.propertyInformation.unitFlat
                                    | toValidator
                            "
                            [disabled]="isDisabledInput"
                        />
                    </tg-input-container>
                </tg-col>
                <tg-col lg="8" md="6" sm="12">
                    <tg-input-container
                        class="hide-optional-label"
                        label="Street name"
                        showRemainingCharacters="false"
                    >
                        <input
                            tgTextInput
                            name="streetName"
                            type="text"
                            (blur)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.streetName
                            "
                            [validation]="
                                validation.propertyInformation.streetName
                                    | toValidator
                            "
                            [disabled]="isDisabledInput"
                        />
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col sm="12">
                    <p class="p-secondary-copy">
                        Enter the full address so we can display a map on your
                        listing.
                    </p>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="hasErrorInStreetNumberAndName">
                <tg-col>
                    <p
                        class="
                            property-information-section__validate-fail
                        "
                    >
                        {{invalidStreetNameErrorMessage}}
                    </p>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="hasErrorInStreetNumberOrNameAndUnitFlat">
                <tg-col>
                    <p class="property-information-section__validate-fail">
                        {{ invalidStreetNameOrNumberErrorMessage }}
                    </p>
                </tg-col>
            </tg-row>
            <tg-row
                class="
                    property-information-section__property-dropdown-selections-row-medium-spacing
                "
            >
                <tg-col md="4" sm="12">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Region"
                    >
                        <select
                            tgSelect
                            name="region"
                            (change)="regionChange()"
                            [(ngModel)]="draftData.propertyInformation.regionId"
                            [validation]="
                                validation.propertyInformation.regionId
                                    | toValidator
                            "
                            [disabled]="isDisabledInput"
                        >
                            <option
                                *ngFor="let region of metadata.regions"
                                [ngValue]="region.regionId"
                            >
                                {{ region.name }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                    <tg-select-container
                        class="hide-optional-label"
                        label="District"
                        [class.o-select--is-disabled]="
                            !draftData.propertyInformation.regionId || isDisabledInput
                        "
                    >
                        <select
                            tgSelect
                            name="district"
                            (change)="districtChange()"
                            [(ngModel)]="
                                draftData.propertyInformation.districtId
                            "
                            [disabled]="!draftData.propertyInformation.regionId || isDisabledInput"
                            [validation]="
                                validation.propertyInformation.districtId
                                    | toValidator
                            "
                        >
                            <option [ngValue]="null">
                                {{
                                    !draftData.propertyInformation.regionId
                                        ? 'Choose a region first'
                                        : 'Choose a district'
                                }}
                            </option>
                            <option
                                *ngFor="
                                    let district of selectedRegion?.districts
                                "
                                [ngValue]="district.districtId"
                            >
                                {{ district.name }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Suburb"
                        [class.o-select--is-disabled]="
                            !draftData.propertyInformation.districtId || isDisabledInput
                        "
                    >
                        <select
                            tgSelect
                            name="suburb"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.suburbId"
                            [disabled]="
                                !draftData.propertyInformation.districtId || isDisabledInput
                            "
                            [validation]="
                                validation.propertyInformation.suburbId
                                    | toValidator
                            "
                        >
                            <option [ngValue]="null">
                                {{
                                    !draftData.propertyInformation.regionId
                                        ? 'Choose a region first'
                                        : 'Choose a suburb'
                                }}
                            </option>
                            <option
                                *ngFor="let suburb of selectedDistrict?.suburbs"
                                [ngValue]="suburb.suburbId"
                            >
                                {{ suburb.name }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
